<template>
    <div class="main-app-container">
        <slot /> <!-- Сюда вставляется контент -->
    </div>
</template>

<script>

</script>

<style scoped>
.main-app-container {
    padding: 4vw;
    padding-top: 30vw;
}
</style>